/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://d3q6qq2zt8nhwv.cloudfront.net/s/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var factory = __webpack_require__(1);
	
	factory.getFrameContainer('write').showWidget();


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var FrameContainerNextGen = __webpack_require__(6);
	
	var factory = {
	    getFrameContainer: function (mode) {
	        var container = new FrameContainerNextGen('ct-custom-read-review-widget', 'nextgen');
	        if (mode) {
	            container.mode = mode;
	        }
	        return container
	    }
	};
	
	module.exports = factory;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?minimize!./next-gen-widget-iframe.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?minimize!./next-gen-widget-iframe.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	exports.push([module.id, ".ct-next-gen-widget{width:100%;overflow:hidden;border:none}", ""]);

/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var FrameContainer = __webpack_require__(7),
	    utils = __webpack_require__(9);
	
	
	var settings = {
	    coursetalkUrl: ("https://www.coursetalk.com/")
	};
	
	var FrameContainerNextGen = FrameContainer.create({
	
	    getBasePath: function () {
	        var mode = '';
	        if (this.mode && this.mode == 'read') {
	            mode = 'read';
	        }
	        if (this.mode && this.mode == 'write') {
	            mode = 'write';
	        }
	        var fitst_part = '/widgets/v2.0/';
	        return utils.join(fitst_part + mode, 'iframe-review-widget/');
	    },
	
	    _template: function () {
	        return '<iframe src="' + utils.join(settings.coursetalkUrl, this._getFrameURL()) + '" id="ct_widget_iframe" ' +
	            'class="ct-next-gen-widget" style="display: none" scrolling="no"></iframe>';
	    }
	
	});
	
	module.exports = FrameContainerNextGen;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass = __webpack_require__(8),
	    Channel = __webpack_require__(10),
	    utils = __webpack_require__(9),
	    url_tools = __webpack_require__(11);
	
	
	var settings = {
	    coursetalkUrl: ("https://www.coursetalk.com/")
	};
	
	
	var FrameContainer = BaseClass.create({
	    init: function (containerId, default_theme, default_provider) {
	        this.default_theme = default_theme || 'default';
	        this.default_provider = default_provider || '';
	        var elements = document.getElementsByClassName('ct-link-logo');
	        if (elements && elements[0]) {
	            elements[0].style.display = "none";
	
	            elements[0].getElementsByTagName('a')[0]
	            .addEventListener('click', this._handleCTLogoClick.bind(this));
	        }
	        this.widgetContainer = window.document.getElementById(containerId);
	        this._getWidgetData();
	    },
	
	    getBasePath: function () {
	        return '/widgets/iframe-review-widget/';
	    },
	
	    _getWidgetData: function () {
	        this.courseKey = this._getCourseKey();
	        this.widgetTheme = utils.trim(this.widgetContainer.getAttribute('data-theme')) || this.default_theme;
	        this.providerKey = utils.trim(this.widgetContainer.getAttribute('data-provider')) || this.default_provider;
	    },
	
	    _getCourseKey: function () {
	        var course_id = utils.trim(this.widgetContainer.getAttribute('data-course'));
	        if (!course_id){
	            course_id = this._getCurrentPageUrl();
	        }
	        return course_id;
	    },
	
	    _getCurrentPageUrl: function () {
	        return window.location.href;
	    },
	
	    _buildQuery: function (url, data) {
	        var basePath = utils.join(url, data.widgetTheme);
	        if (data.providerKey) {
	            basePath = utils.join(basePath, data.providerKey);
	        }
	        basePath = utils.join(basePath, data.courseKey);
	        return basePath;
	    },
	
	    _getFrameURL: function () {
	        var basePath = this._buildQuery(this.getBasePath(), {
	            widgetTheme: this.widgetTheme,
	            providerKey: this.providerKey,
	            courseKey: this.courseKey
	        });
	        var current_url = this._getCurrentPageUrl();
	        return url_tools.cloneUrlParams(current_url, basePath, ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']);
	    },
	
	    _template: function () {
	        return '<iframe src="' + utils.join(settings.coursetalkUrl, this._getFrameURL()) + '" id="ct_widget_iframe" ' +
	            'class="ct-iframe" style="display: none" scrolling="no"></iframe>'
	    },
	
	    showWidget: function () {
	        this.widgetContainer.innerHTML = this._template();
	        this.iframeElement = window.document.getElementById('ct_widget_iframe');
	        this.iframeElement.addEventListener('load', this._handleIFrameLoad.bind(this), false);
	    },
	
	    _handleIFrameLoad: function () {
	        this.chan = Channel.build({
	            window: this.iframeElement.contentWindow,
	            origin: "*",
	            scope: "courseTalkWidgetScope",
	            onReady: function() {}
	        });
	        this.chan.bind("resize", this._chanMessageResize.bind(this));
	        this.chan.bind("isMultipleColumns", this.isMultipleColumns.bind(this));
	        this.chan.bind("addJSON_LD", this.addJSON_LD.bind(this));
	        this.chan.bind("getCurrentPageUrl", this._getCurrentPageUrl.bind(this));
	        window.addEventListener('resize', this._handleWindowResize.bind(this), false);
	    },
	
	    _chanMessageResize: function (trans, s) {
	        this.iframeElement.style.height= s + "px";
	        if (this.iframeElement.style.display == 'none') {
	            this.iframeElement.style.display = "block";
	            var elements = document.getElementsByClassName('ct-link-logo');
	            if (elements && elements[0]) {
	                elements[0].style.display = "block";
	            }
	            this._handleWindowResize();
	        }
	    },
	
	    _handleWindowResize: function () {
	        this.chan.call({method: 'getHeight',
	           success: function (s) {
	               this.iframeElement.style.height= s + "px";
	           }.bind(this)})
	    },
	
	    _handleCTLogoClick: function (event) {
	        this.chan.notify({ method:"trackCTLogoClick" });
	    },
	
	    isMultipleColumns: function () {
	        var classes = this.widgetContainer.className;
	        return classes.indexOf("ct--multiple-columns") > -1;
	
	    },
	
	    addJSON_LD: function (trans, jsonSting) {
	        var script = document.createElement('script');
	        script.setAttribute('type', 'application/ld+json');
	        script.innerText = jsonSting;
	        document.body.appendChild(script);
	    }
	});
	
	module.exports = FrameContainer;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(9);
	
	
	var BaseClass = {
	
	    init: function () {
	
	    },
	
	    create: function (extention) {
	        var self = this;
	        if (typeof(self) === 'function') {
	            self = self.prototype;
	        }
	        var data = utils.extend(utils.extend({}, self), extention);
	        var construnctor = function () {
	            this.init.apply(this, arguments);
	        };
	        construnctor.prototype = data;
	        construnctor.create = data.create;
	        return construnctor;
	    }
	};
	
	module.exports = BaseClass;


/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	function extend() {
	    var obj = arguments[0],
	        processor = false,
	        startIndex = 1;
	    if (obj === true || obj === 'deepcopy') {
	        processor = _deepcopy;
	        obj = arguments[startIndex];
	        startIndex++;
	    }
	    if (typeof obj === 'function') {
	        processor = obj;
	        obj = arguments[startIndex];
	        startIndex++;
	    }
	    for (var i = startIndex; i < arguments.length; i++) {
	        obj = _extend(obj, arguments[i], processor);
	    }
	    return obj;
	}
	function _extend(a, b, processor) {
	    for (var prop in b) {
	        if (b.hasOwnProperty(prop)) {
	            if (!( prop === "constructor" && a === window )) {
	                if (b[prop] === undefined) {
	                    delete a[prop];
	                } else {
	                    if (processor && typeof processor === 'function') {
	                        var value = processor(a[prop], b[prop], function (a, b) {
	                            return b;
	                        });
	                        if (value !== undefined) {
	                            a[prop] = value;
	                        }
	                    } else {
	                        a[prop] = b[prop];
	                    }
	                }
	            }
	        }
	    }
	    return a;
	}
	function _deepcopy(a, b, defaultProcessor) {
	    if (typeof a === 'object' && typeof b === 'object') {
	        return extend(true, a, b);
	    } else {
	        return defaultProcessor(a, b);
	    }
	}
	function format(string, obj) {
	    var result = string;
	    if (!(obj instanceof Object) || arguments.length > 2) {
	        var args = [];
	        for (var i = 1; i < arguments.length; i++) {
	            args.push(arguments[i]);
	        }
	        obj = args;
	    }
	    for (var name in obj) {
	        if (obj.hasOwnProperty(name)) {
	            result = replaceToken(result, name, obj[name]);
	        }
	    }
	    return result;
	}
	function replaceToken(string, tokenName, value) {
	    var pattern = new RegExp("{\\s*?" + tokenName + "\\s*?\\}", "ig");
	    if (string && pattern.test(string)) {
	        string = string.replace(pattern, value);
	    }
	    return string;
	}
	function trim(string) {
	    if (!string) {
	        return string;
	    }
	    return string.replace(/^\s+|\s+$/gm,'');
	}
	function join () {
	    var str = arguments[0];
	    for (var i = 1; i < arguments.length; i++) {
	        str = _join(str, arguments[i]);
	    }
	    return str;
	}
	function _join (pathLeft, pathRight) {
	    if (!pathLeft) {
	        return pathRight;
	    }
	    if (!pathRight) {
	        return pathLeft;
	    }
	    if (pathLeft[pathLeft.length - 1] === '/' || pathLeft[pathLeft.length - 1] === '\\') {
	        pathLeft = pathLeft.substring(0, pathLeft.length - 1);
	    }
	    if (pathRight[0] !== '/' && pathRight[0] !== '\\') {
	        pathRight = '/' + pathRight;
	    }
	    return pathLeft + pathRight;
	}
	function bindArgs(func) {
	    var args = [];
	    for (var i = 1; i < arguments.length; i++) {
	        args.push(arguments[i]);
	    }
	    return function () {
	        var funcArgs = [];
	        for (var i = 0; i < args.length; i++) {
	            funcArgs.push(args[i]);
	        }
	        for (i = 0; i < arguments.length; i++) {
	            funcArgs.push(arguments[i]);
	        }
	        return func.apply(this, funcArgs);
	    };
	}
	function memorize(func, hasher) {
	    var wrapper = function(key) {
	        var cache = wrapper.cache;
	        var cache_key = '' + (hasher ? hasher.apply(this, arguments) : key);
	        if (!cache.hasOwnProperty(cache_key)) {
	            cache[cache_key] = func.apply(this, arguments);
	        }
	        return cache[cache_key];
	    };
	    wrapper.cache = {};
	    return wrapper;
	}
	function ctMixpanelCommonProps (course) {
	    return {
	        'CourseName' : course.name,
	        'CourseProvider' : course.platform_name,
	        'CourseRating' : course.rating,
	        '# of Reviews' : course.reviews_count
	    };
	}
	module.exports = {
	    extend: extend,
	    format: format,
	    join: join,
	    bindArgs: bindArgs,
	    ct_mixpanel_props: ctMixpanelCommonProps,
	    memorize: memorize,
	    trim: trim
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * js_channel is a very lightweight abstraction on top of
	 * postMessage which defines message formats and semantics
	 * to support interactions more rich than just message passing
	 * js_channel supports:
	 *  + query/response - traditional rpc
	 *  + query/update/response - incremental async return of results
	 *    to a query
	 *  + notifications - fire and forget
	 *  + error handling
	 *
	 * js_channel is based heavily on json-rpc, but is focused at the
	 * problem of inter-iframe RPC.
	 *
	 * Message types:
	 *  There are 5 types of messages that can flow over this channel,
	 *  and you may determine what type of message an object is by
	 *  examining its parameters:
	 *  1. Requests
	 *    + integer id
	 *    + string method
	 *    + (optional) any params
	 *  2. Callback Invocations (or just "Callbacks")
	 *    + integer id
	 *    + string callback
	 *    + (optional) params
	 *  3. Error Responses (or just "Errors)
	 *    + integer id
	 *    + string error
	 *    + (optional) string message
	 *  4. Responses
	 *    + integer id
	 *    + (optional) any result
	 *  5. Notifications
	 *    + string method
	 *    + (optional) any params
	 */
	
	;var Channel = (function() {
	    "use strict";
	
	    // current transaction id, start out at a random *odd* number between 1 and a million
	    // There is one current transaction counter id per page, and it's shared between
	    // channel instances.  That means of all messages posted from a single javascript
	    // evaluation context, we'll never have two with the same id.
	    var s_curTranId = Math.floor(Math.random()*1000001);
	
	    // no two bound channels in the same javascript evaluation context may have the same origin, scope, and window.
	    // futher if two bound channels have the same window and scope, they may not have *overlapping* origins
	    // (either one or both support '*').  This restriction allows a single onMessage handler to efficiently
	    // route messages based on origin and scope.  The s_boundChans maps origins to scopes, to message
	    // handlers.  Request and Notification messages are routed using this table.
	    // Finally, channels are inserted into this table when built, and removed when destroyed.
	    var s_boundChans = { };
	
	    // add a channel to s_boundChans, throwing if a dup exists
	    function s_addBoundChan(win, origin, scope, handler) {
	        function hasWin(arr) {
	            for (var i = 0; i < arr.length; i++) if (arr[i].win === win) return true;
	            return false;
	        }
	
	        // does she exist?
	        var exists = false;
	
	
	        if (origin === '*') {
	            // we must check all other origins, sadly.
	            for (var k in s_boundChans) {
	                if (!s_boundChans.hasOwnProperty(k)) continue;
	                if (k === '*') continue;
	                if (typeof s_boundChans[k][scope] === 'object') {
	                    exists = hasWin(s_boundChans[k][scope]);
	                    if (exists) break;
	                }
	            }
	        } else {
	            // we must check only '*'
	            if ((s_boundChans['*'] && s_boundChans['*'][scope])) {
	                exists = hasWin(s_boundChans['*'][scope]);
	            }
	            if (!exists && s_boundChans[origin] && s_boundChans[origin][scope])
	            {
	                exists = hasWin(s_boundChans[origin][scope]);
	            }
	        }
	        if (exists) throw "A channel is already bound to the same window which overlaps with origin '"+ origin +"' and has scope '"+scope+"'";
	
	        if (typeof s_boundChans[origin] != 'object') s_boundChans[origin] = { };
	        if (typeof s_boundChans[origin][scope] != 'object') s_boundChans[origin][scope] = [ ];
	        s_boundChans[origin][scope].push({win: win, handler: handler});
	    }
	
	    function s_removeBoundChan(win, origin, scope) {
	        var arr = s_boundChans[origin][scope];
	        for (var i = 0; i < arr.length; i++) {
	            if (arr[i].win === win) {
	                arr.splice(i,1);
	            }
	        }
	        if (s_boundChans[origin][scope].length === 0) {
	            delete s_boundChans[origin][scope];
	        }
	    }
	
	    function s_isArray(obj) {
	        if (Array.isArray) return Array.isArray(obj);
	        else {
	            return (obj.constructor.toString().indexOf("Array") != -1);
	        }
	    }
	
	    // No two outstanding outbound messages may have the same id, period.  Given that, a single table
	    // mapping "transaction ids" to message handlers, allows efficient routing of Callback, Error, and
	    // Response messages.  Entries are added to this table when requests are sent, and removed when
	    // responses are received.
	    var s_transIds = { };
	
	    // class singleton onMessage handler
	    // this function is registered once and all incoming messages route through here.  This
	    // arrangement allows certain efficiencies, message data is only parsed once and dispatch
	    // is more efficient, especially for large numbers of simultaneous channels.
	    var s_onMessage = function(e) {
	        try {
	          var m = JSON.parse(e.data);
	          if (typeof m !== 'object' || m === null) throw "malformed";
	        } catch(e) {
	          // just ignore any posted messages that do not consist of valid JSON
	          return;
	        }
	
	        var w = e.source;
	        var o = e.origin;
	        var s, i, meth;
	
	        if (typeof m.method === 'string') {
	            var ar = m.method.split('::');
	            if (ar.length == 2) {
	                s = ar[0];
	                meth = ar[1];
	            } else {
	                meth = m.method;
	            }
	        }
	
	        if (typeof m.id !== 'undefined') i = m.id;
	
	        // w is message source window
	        // o is message origin
	        // m is parsed message
	        // s is message scope
	        // i is message id (or undefined)
	        // meth is unscoped method name
	        // ^^ based on these factors we can route the message
	
	        // if it has a method it's either a notification or a request,
	        // route using s_boundChans
	        if (typeof meth === 'string') {
	            var delivered = false;
	            if (s_boundChans[o] && s_boundChans[o][s]) {
	                for (var j = 0; j < s_boundChans[o][s].length; j++) {
	                    if (s_boundChans[o][s][j].win === w) {
	                        s_boundChans[o][s][j].handler(o, meth, m);
	                        delivered = true;
	                        break;
	                    }
	                }
	            }
	
	            if (!delivered && s_boundChans['*'] && s_boundChans['*'][s]) {
	                for (var j = 0; j < s_boundChans['*'][s].length; j++) {
	                    if (s_boundChans['*'][s][j].win === w) {
	                        s_boundChans['*'][s][j].handler(o, meth, m);
	                        break;
	                    }
	                }
	            }
	        }
	        // otherwise it must have an id (or be poorly formed
	        else if (typeof i != 'undefined') {
	            if (s_transIds[i]) s_transIds[i](o, meth, m);
	        }
	    };
	
	    // Setup postMessage event listeners
	    if (window.addEventListener) window.addEventListener('message', s_onMessage, false);
	    else if(window.attachEvent) window.attachEvent('onmessage', s_onMessage);
	
	    /* a messaging channel is constructed from a window and an origin.
	     * the channel will assert that all messages received over the
	     * channel match the origin
	     *
	     * Arguments to Channel.build(cfg):
	     *
	     *   cfg.window - the remote window with which we'll communicate
	     *   cfg.origin - the expected origin of the remote window, may be '*'
	     *                which matches any origin
	     *   cfg.scope  - the 'scope' of messages.  a scope string that is
	     *                prepended to message names.  local and remote endpoints
	     *                of a single channel must agree upon scope. Scope may
	     *                not contain double colons ('::').
	     *   cfg.debugOutput - A boolean value.  If true and window.console.log is
	     *                a function, then debug strings will be emitted to that
	     *                function.
	     *   cfg.debugOutput - A boolean value.  If true and window.console.log is
	     *                a function, then debug strings will be emitted to that
	     *                function.
	     *   cfg.postMessageObserver - A function that will be passed two arguments,
	     *                an origin and a message.  It will be passed these immediately
	     *                before messages are posted.
	     *   cfg.gotMessageObserver - A function that will be passed two arguments,
	     *                an origin and a message.  It will be passed these arguments
	     *                immediately after they pass scope and origin checks, but before
	     *                they are processed.
	     *   cfg.onReady - A function that will be invoked when a channel becomes "ready",
	     *                this occurs once both sides of the channel have been
	     *                instantiated and an application level handshake is exchanged.
	     *                the onReady function will be passed a single argument which is
	     *                the channel object that was returned from build().
	     */
	    var _channel = {
	        build: function(cfg) {
	            var debug = function(m) {
	                if (cfg.debugOutput && window.console && window.console.log) {
	                    // try to stringify, if it doesn't work we'll let javascript's built in toString do its magic
	                    try { if (typeof m !== 'string') m = JSON.stringify(m); } catch(e) { }
	                    console.log("["+chanId+"] " + m);
	                }
	            };
	
	            /* browser capabilities check */
	            if (!window.postMessage) throw("jschannel cannot run this browser, no postMessage");
	            if (!window.JSON || !window.JSON.stringify || ! window.JSON.parse) {
	                throw("jschannel cannot run this browser, no JSON parsing/serialization");
	            }
	
	            /* basic argument validation */
	            if (typeof cfg != 'object') throw("Channel build invoked without a proper object argument");
	
	            if (!cfg.window || !cfg.window.postMessage) throw("Channel.build() called without a valid window argument");
	
	            /* we'd have to do a little more work to be able to run multiple channels that intercommunicate the same
	             * window...  Not sure if we care to support that */
	            if (window === cfg.window) throw("target window is same as present window -- not allowed");
	
	            // let's require that the client specify an origin.  if we just assume '*' we'll be
	            // propagating unsafe practices.  that would be lame.
	            var validOrigin = false;
	            if (typeof cfg.origin === 'string') {
	                var oMatch;
	                if (cfg.origin === "*") validOrigin = true;
	                // allow valid domains under http and https.  Also, trim paths off otherwise valid origins.
	                else if (null !== (oMatch = cfg.origin.match(/^https?:\/\/(?:[-a-zA-Z0-9_\.])+(?::\d+)?/))) {
	                    cfg.origin = oMatch[0].toLowerCase();
	                    validOrigin = true;
	                }
	            }
	
	            if (!validOrigin) throw ("Channel.build() called with an invalid origin");
	
	            if (typeof cfg.scope !== 'undefined') {
	                if (typeof cfg.scope !== 'string') throw 'scope, when specified, must be a string';
	                if (cfg.scope.split('::').length > 1) throw "scope may not contain double colons: '::'";
	            }
	
	            /* private variables */
	            // generate a random and psuedo unique id for this channel
	            var chanId = (function () {
	                var text = "";
	                var alpha = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
	                for(var i=0; i < 5; i++) text += alpha.charAt(Math.floor(Math.random() * alpha.length));
	                return text;
	            })();
	
	            // registrations: mapping method names to call objects
	            var regTbl = { };
	            // current oustanding sent requests
	            var outTbl = { };
	            // current oustanding received requests
	            var inTbl = { };
	            // are we ready yet?  when false we will block outbound messages.
	            var ready = false;
	            var pendingQueue = [ ];
	
	            var createTransaction = function(id,origin,callbacks) {
	                var shouldDelayReturn = false;
	                var completed = false;
	
	                return {
	                    origin: origin,
	                    invoke: function(cbName, v) {
	                        // verify in table
	                        if (!inTbl[id]) throw "attempting to invoke a callback of a nonexistent transaction: " + id;
	                        // verify that the callback name is valid
	                        var valid = false;
	                        for (var i = 0; i < callbacks.length; i++) if (cbName === callbacks[i]) { valid = true; break; }
	                        if (!valid) throw "request supports no such callback '" + cbName + "'";
	
	                        // send callback invocation
	                        postMessage({ id: id, callback: cbName, params: v});
	                    },
	                    error: function(error, message) {
	                        completed = true;
	                        // verify in table
	                        if (!inTbl[id]) throw "error called for nonexistent message: " + id;
	
	                        // remove transaction from table
	                        delete inTbl[id];
	
	                        // send error
	                        postMessage({ id: id, error: error, message: message });
	                    },
	                    complete: function(v) {
	                        completed = true;
	                        // verify in table
	                        if (!inTbl[id]) throw "complete called for nonexistent message: " + id;
	                        // remove transaction from table
	                        delete inTbl[id];
	                        // send complete
	                        postMessage({ id: id, result: v });
	                    },
	                    delayReturn: function(delay) {
	                        if (typeof delay === 'boolean') {
	                            shouldDelayReturn = (delay === true);
	                        }
	                        return shouldDelayReturn;
	                    },
	                    completed: function() {
	                        return completed;
	                    }
	                };
	            };
	
	            var setTransactionTimeout = function(transId, timeout, method) {
	              return window.setTimeout(function() {
	                if (outTbl[transId]) {
	                  // XXX: what if client code raises an exception here?
	                  var msg = "timeout (" + timeout + "ms) exceeded on method '" + method + "'";
	                  (1,outTbl[transId].error)("timeout_error", msg);
	                  delete outTbl[transId];
	                  delete s_transIds[transId];
	                }
	              }, timeout);
	            };
	
	            var onMessage = function(origin, method, m) {
	                // if an observer was specified at allocation time, invoke it
	                if (typeof cfg.gotMessageObserver === 'function') {
	                    // pass observer a clone of the object so that our
	                    // manipulations are not visible (i.e. method unscoping).
	                    // This is not particularly efficient, but then we expect
	                    // that message observers are primarily for debugging anyway.
	                    try {
	                        cfg.gotMessageObserver(origin, m);
	                    } catch (e) {
	                        debug("gotMessageObserver() raised an exception: " + e.toString());
	                    }
	                }
	
	                // now, what type of message is this?
	                if (m.id && method) {
	                    // a request!  do we have a registered handler for this request?
	                    if (regTbl[method]) {
	                        var trans = createTransaction(m.id, origin, m.callbacks ? m.callbacks : [ ]);
	                        inTbl[m.id] = { };
	                        try {
	                            // callback handling.  we'll magically create functions inside the parameter list for each
	                            // callback
	                            if (m.callbacks && s_isArray(m.callbacks) && m.callbacks.length > 0) {
	                                for (var i = 0; i < m.callbacks.length; i++) {
	                                    var path = m.callbacks[i];
	                                    var obj = m.params;
	                                    var pathItems = path.split('/');
	                                    for (var j = 0; j < pathItems.length - 1; j++) {
	                                        var cp = pathItems[j];
	                                        if (typeof obj[cp] !== 'object') obj[cp] = { };
	                                        obj = obj[cp];
	                                    }
	                                    obj[pathItems[pathItems.length - 1]] = (function() {
	                                        var cbName = path;
	                                        return function(params) {
	                                            return trans.invoke(cbName, params);
	                                        };
	                                    })();
	                                }
	                            }
	                            var resp = regTbl[method](trans, m.params);
	                            if (!trans.delayReturn() && !trans.completed()) trans.complete(resp);
	                        } catch(e) {
	                            // automagic handling of exceptions:
	                            var error = "runtime_error";
	                            var message = null;
	                            // * if it's a string then it gets an error code of 'runtime_error' and string is the message
	                            if (typeof e === 'string') {
	                                message = e;
	                            } else if (typeof e === 'object') {
	                                // either an array or an object
	                                // * if it's an array of length two, then  array[0] is the code, array[1] is the error message
	                                if (e && s_isArray(e) && e.length == 2) {
	                                    error = e[0];
	                                    message = e[1];
	                                }
	                                // * if it's an object then we'll look form error and message parameters
	                                else if (typeof e.error === 'string') {
	                                    error = e.error;
	                                    if (!e.message) message = "";
	                                    else if (typeof e.message === 'string') message = e.message;
	                                    else e = e.message; // let the stringify/toString message give us a reasonable verbose error string
	                                }
	                            }
	
	                            // message is *still* null, let's try harder
	                            if (message === null) {
	                                try {
	                                    message = JSON.stringify(e);
	                                    /* On MSIE8, this can result in 'out of memory', which
	                                     * leaves message undefined. */
	                                    if (typeof(message) == 'undefined')
	                                      message = e.toString();
	                                } catch (e2) {
	                                    message = e.toString();
	                                }
	                            }
	
	                            trans.error(error,message);
	                        }
	                    }
	                } else if (m.id && m.callback) {
	                    if (!outTbl[m.id] ||!outTbl[m.id].callbacks || !outTbl[m.id].callbacks[m.callback])
	                    {
	                        debug("ignoring invalid callback, id:"+m.id+ " (" + m.callback +")");
	                    } else {
	                        // XXX: what if client code raises an exception here?
	                        outTbl[m.id].callbacks[m.callback](m.params);
	                    }
	                } else if (m.id) {
	                    if (!outTbl[m.id]) {
	                        debug("ignoring invalid response: " + m.id);
	                    } else {
	                        // XXX: what if client code raises an exception here?
	                        if (m.error) {
	                            (1,outTbl[m.id].error)(m.error, m.message);
	                        } else {
	                            if (m.result !== undefined) (1,outTbl[m.id].success)(m.result);
	                            else (1,outTbl[m.id].success)();
	                        }
	                        delete outTbl[m.id];
	                        delete s_transIds[m.id];
	                    }
	                } else if (method) {
	                    // tis a notification.
	                    if (regTbl[method]) {
	                        // yep, there's a handler for that.
	                        // transaction has only origin for notifications.
	                        regTbl[method]({ origin: origin }, m.params);
	                        // if the client throws, we'll just let it bubble out
	                        // what can we do?  Also, here we'll ignore return values
	                    }
	                }
	            };
	
	            // now register our bound channel for msg routing
	            s_addBoundChan(cfg.window, cfg.origin, ((typeof cfg.scope === 'string') ? cfg.scope : ''), onMessage);
	
	            // scope method names based on cfg.scope specified when the Channel was instantiated
	            var scopeMethod = function(m) {
	                if (typeof cfg.scope === 'string' && cfg.scope.length) m = [cfg.scope, m].join("::");
	                return m;
	            };
	
	            // a small wrapper around postmessage whose primary function is to handle the
	            // case that clients start sending messages before the other end is "ready"
	            var postMessage = function(msg, force) {
	                if (!msg) throw "postMessage called with null message";
	
	                // delay posting if we're not ready yet.
	                var verb = (ready ? "post  " : "queue ");
	                debug(verb + " message: " + JSON.stringify(msg));
	                if (!force && !ready) {
	                    pendingQueue.push(msg);
	                } else {
	                    if (typeof cfg.postMessageObserver === 'function') {
	                        try {
	                            cfg.postMessageObserver(cfg.origin, msg);
	                        } catch (e) {
	                            debug("postMessageObserver() raised an exception: " + e.toString());
	                        }
	                    }
	
	                    cfg.window.postMessage(JSON.stringify(msg), cfg.origin);
	                }
	            };
	
	            var onReady = function(trans, type) {
	                debug('ready msg received');
	                if (ready) throw "received ready message while in ready state.  help!";
	
	                if (type === 'ping') {
	                    chanId += '-R';
	                } else {
	                    chanId += '-L';
	                }
	
	                obj.unbind('__ready'); // now this handler isn't needed any more.
	                ready = true;
	                debug('ready msg accepted.');
	
	                if (type === 'ping') {
	                    obj.notify({ method: '__ready', params: 'pong' });
	                }
	
	                // flush queue
	                while (pendingQueue.length) {
	                    postMessage(pendingQueue.pop());
	                }
	
	                // invoke onReady observer if provided
	                if (typeof cfg.onReady === 'function') cfg.onReady(obj);
	            };
	
	            var obj = {
	                // tries to unbind a bound message handler.  returns false if not possible
	                unbind: function (method) {
	                    if (regTbl[method]) {
	                        if (!(delete regTbl[method])) throw ("can't delete method: " + method);
	                        return true;
	                    }
	                    return false;
	                },
	                bind: function (method, cb) {
	                    if (!method || typeof method !== 'string') throw "'method' argument to bind must be string";
	                    if (!cb || typeof cb !== 'function') throw "callback missing from bind params";
	
	                    if (regTbl[method]) throw "method '"+method+"' is already bound!";
	                    regTbl[method] = cb;
	                    return this;
	                },
	                call: function(m) {
	                    if (!m) throw 'missing arguments to call function';
	                    if (!m.method || typeof m.method !== 'string') throw "'method' argument to call must be string";
	                    if (!m.success || typeof m.success !== 'function') throw "'success' callback missing from call";
	
	                    // now it's time to support the 'callback' feature of jschannel.  We'll traverse the argument
	                    // object and pick out all of the functions that were passed as arguments.
	                    var callbacks = { };
	                    var callbackNames = [ ];
	                    var seen = [ ];
	
	                    var pruneFunctions = function (path, obj) {
	                        if (seen.indexOf(obj) >= 0) {
	                            throw "params cannot be a recursive data structure"
	                        }
	                        seen.push(obj);
	                       
	                        if (typeof obj === 'object') {
	                            for (var k in obj) {
	                                if (!obj.hasOwnProperty(k)) continue;
	                                var np = path + (path.length ? '/' : '') + k;
	                                if (typeof obj[k] === 'function') {
	                                    callbacks[np] = obj[k];
	                                    callbackNames.push(np);
	                                    delete obj[k];
	                                } else if (typeof obj[k] === 'object') {
	                                    pruneFunctions(np, obj[k]);
	                                }
	                            }
	                        }
	                    };
	                    pruneFunctions("", m.params);
	
	                    // build a 'request' message and send it
	                    var msg = { id: s_curTranId, method: scopeMethod(m.method), params: m.params };
	                    if (callbackNames.length) msg.callbacks = callbackNames;
	
	                    if (m.timeout)
	                      // XXX: This function returns a timeout ID, but we don't do anything with it.
	                      // We might want to keep track of it so we can cancel it using clearTimeout()
	                      // when the transaction completes.
	                      setTransactionTimeout(s_curTranId, m.timeout, scopeMethod(m.method));
	
	                    // insert into the transaction table
	                    outTbl[s_curTranId] = { callbacks: callbacks, error: m.error, success: m.success };
	                    s_transIds[s_curTranId] = onMessage;
	
	                    // increment current id
	                    s_curTranId++;
	
	                    postMessage(msg);
	                },
	                notify: function(m) {
	                    if (!m) throw 'missing arguments to notify function';
	                    if (!m.method || typeof m.method !== 'string') throw "'method' argument to notify must be string";
	
	                    // no need to go into any transaction table
	                    postMessage({ method: scopeMethod(m.method), params: m.params });
	                },
	                destroy: function () {
	                    s_removeBoundChan(cfg.window, cfg.origin, ((typeof cfg.scope === 'string') ? cfg.scope : ''));
	                    if (window.removeEventListener) window.removeEventListener('message', onMessage, false);
	                    else if(window.detachEvent) window.detachEvent('onmessage', onMessage);
	                    ready = false;
	                    regTbl = { };
	                    inTbl = { };
	                    outTbl = { };
	                    cfg.origin = null;
	                    pendingQueue = [ ];
	                    debug("channel destroyed");
	                    chanId = "";
	                }
	            };
	
	            obj.bind('__ready', onReady);
	            setTimeout(function() {
	                postMessage({ method: scopeMethod('__ready'), params: "ping" }, true);
	            }, 0);
	
	            return obj;
	        }
	    };
	
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = _channel;
	        }
	        exports.Channel = _channel;
	    }
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return _channel;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	
	    return _channel;
	})();


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var YouAreI = __webpack_require__(12);
	
	
	function cloneUrlParams(source_url, out_url, params) {
	    var copy_all = !params;
	    var source_uri = new YouAreI(source_url);
	    var out_uri = new YouAreI(out_url);
	    var source_query = source_uri.query_get();
	    var out_query = out_uri.query_get();
	    Object.keys(source_query).forEach(function (param_name) {
	        var not_param_in_out_url = !out_query.hasOwnProperty(param_name);
	        var can_copy_param = copy_all || params.indexOf(param_name) >= 0;
	        if (not_param_in_out_url && can_copy_param) {
	            var val = {};
	            val[param_name] = source_query[param_name];
	            out_uri.query_push(val);
	        }
	    });
	    return out_uri.to_string();
	}
	
	
	module.exports = {
	    cloneUrlParams: cloneUrlParams
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root,factory){if(true){!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof exports==="object"){module.exports=factory()}else{root.YouAreI=factory()}})(this,function(){var uri_re=/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;var auth_re=/^([^\@]+)\@/;var port_re=/:(\d+)$/;var qp_re=/^([^=]+)(?:=(.*))?$/;function toCamel(str){return str.replace(/(\_[a-z])/g,function($1){return $1.toUpperCase().replace("_","")})}var is_array=function(object){return"[object Array]"===Object.prototype.toString.call(object)};function YouAreI(uri){return this.parse(uri)}YouAreI.prototype={parse:function(uri){var f=uri?uri.match(uri_re):[];return this.scheme(f[2]||"").authority(f[4]||"").path_set(f[5]||"").fragment(f[9]||"").query_set(f[7]||"")},clone:function(){var copy=this.constructor();for(var attr in this){copy[attr]=this[attr]}return copy},gs:function(val,tar,fn){if(val!==undefined){this[tar]=val;return this}else{return fn?fn(this[tar]):this[tar]}},fragment:function(f){return this.gs(f,"_fragment")},user_info:function(f){return this.gs(f,"_userinfo",function(r){return r===undefined?r:encodeURI(r)})},path_set:function(f){this._path_parse(f);return this},path_basename_set:function(name){if(this._path_trailing_slash){this._path.push(name);this._path_trailing_slash=false}else{this._path[this._path.length-1]=name}return this},_path_parse:function(path){path=decodeURIComponent(path||"");var spl=path.split("/");this._path_leading_slash=false;this._path_trailing_slash=false;if(path.match(/^\//)){this._path_leading_slash=true;spl.shift()}if(spl.length>1&&path.match(/\/$/)){this._path_trailing_slash=true;spl.pop()}this._path=spl;return spl},path_to_string:function(opt_path){path=(opt_path||this._path).join("/");if(this._path_leading_slash)path="/"+path;if(this._path_trailing_slash)path=path+"/";return path},path_to_dir:function(){var path=this._path;if(!this._path_trailing_slash){path.pop();path.push("")}return this.path_to_string(path)},path_parts:function(f){return this.gs(f,"_path")},scheme:function(f){return this.gs(f,"_scheme")},port:function(f){return this.gs(f,"_port")},host:function(f){return this.gs(f,"_host")},protocol:function(){return this.scheme.toLowerCase()},authority:function(authority){var auth,port,userinfo;if(authority!==undefined){this._authority=authority;if(auth=authority.match(auth_re)){authority=authority.replace(auth_re,"");this.user_info(auth[1])}if(port=authority.match(port_re)){authority=authority.replace(port_re,"");this.port(port[1])}this.host(authority);return this}else{authority="";if(userinfo=this.user_info()){authority=userinfo+"@"}authority+=this.host();if(port=this.port()){authority+=":"+port}return authority}},to_string:function(){var q=this.query_to_string(),f=this.fragment(),s=this.scheme();return(s?s+"://":"")+this.authority()+this.path_to_string()+(q?"?"+q:"")+(f?"#"+f:"")},query_to_string:function(){var pairs=[],n=this._query[0],v=this._query[1];for(var i=0;i<n.length;i++){pairs.push(encodeURIComponent(n[i])+"="+encodeURIComponent(v[i]))}return pairs.join("&")},query_get:function(limit){var dict={},opts=this._query;for(var i=0;i<opts[0].length;i++){var k=opts[0][i],v=opts[1][i];if(limit&&k!==limit){continue}if(dict[k]){continue}else{dict[k]=v}}return limit?dict[limit]:dict},query_get_all:function(limit){var dict={},opts=this._query;for(var i=0;i<opts[0].length;i++){var k=opts[0][i],v=opts[1][i];if(limit&&k!==limit){continue}if(dict[k]){dict[k].push(v)}else{dict[k]=[v]}}return limit?dict[limit]:dict},_query_parse:function(raw){var struct=[[],[]],pairs=raw.split(/&|;/);for(var j=0;j<pairs.length;j++){var name,value,pair=pairs[j],n_pair=pair.match(qp_re);if(n_pair){if(typeof n_pair[n_pair.length-1]!=="undefined"){n_pair.shift();for(var i=0;i<n_pair.length;i++){var p=n_pair[i];struct[i].push(decodeURIComponent(p.replace("+"," ","g")))}}}}return struct},_query_toList:function(p,q,opt){for(var key in opt){if(is_array(opt[key])){for(var valn in opt[key]){var val=opt[key][valn];p.push(key);q.push(val)}}else if(opt[key]!==undefined&&opt[key]!==null){p.push(key);q.push(opt[key])}}return[p,q]},query_push:function(opt){this._query=this._query_toList(this._query[0],this._query[1],opt);return this},query_merge:function(opt){var p=this._query[0],q=this._query[1];for(var key in opt){var kset=false;for(var i=0;i<p.length;i++){var x_key=p[i];if(key===x_key){if(kset){p.splice(i,1);q.splice(i,1);continue}if(is_array(opt[key])){q[i]=opt[key].shift()}else if(opt[key]===undefined||opt[key]===null){p.splice(i,1);q.splice(i,1);delete opt[key]}else{q[i]=opt[key];delete opt[key]}kset=true}}}this.query_push(opt);return this},query_clear:function(){this._query=[[],[]];return this},query_set:function(){var args=Array.prototype.slice.call(arguments);if(args.length===1){if(typeof args[0]==="object"){this._query=this._query_toList([],[],args[0])}else{this._query=this._query_parse(args[0])}}else if(args.length===0){this.query_clear()}else{var obj={};obj[args[0]]=args[1];this.query_merge(obj)}return this}};for(var name in YouAreI.prototype){if(!name.match(/^_/)){var cName=toCamel(name);YouAreI.prototype[cName]=YouAreI.prototype[name]}}return YouAreI});

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** js/widgets/coursetalk-write-reviews.js
 **/